import React, {useContext, useState} from "react";
import {SearchOptionsContext} from "../../context/search-options-context";
import {Link} from "react-router-dom";
import {useMediaQuery} from "react-responsive";
import logoIcon from "../../assets/images/icons/logo_icon.svg";

function Brands() {
    const isMobile = useMediaQuery({maxWidth: 767});
    const initialCount = isMobile ? 6 : 8;
    const searchOptions = useContext(SearchOptionsContext);
    const brands = searchOptions.brandsAndModels;
    const [expanded, setExpanded] = useState(false);

    if (!brands || brands.length === 0) {
        return null;
    }

    const visibleBrands = expanded ? brands : brands.slice(0, initialCount);
    const hasMore = brands.length > initialCount;

    return (
        <section id="marki">
            <div className="container">
                <h2 className="brands-heading">
                    Wybierz spośród {brands.length} marek dostępnych na stronie
                </h2>
                <div className="brands-grid">
                    {visibleBrands.map(brand => (
                        <Link
                            key={brand.identifier}
                            to={{pathname: "/lista-ofert", search: "brands=" + brand.name}}
                            className="brand-card"
                        >
                            <div className="brand-card-img">
                                <img src={brand.image} alt={brand.name}/>
                            </div>
                            <span className="brand-card-name">{brand.name}</span>
                        </Link>
                    ))}
                </div>
                {hasMore && (
                    <div className="brands-expand">
                        <button
                            className={"brands-expand-btn" + (expanded ? " expanded" : "")}
                            onClick={() => setExpanded(prev => !prev)}
                            type="button"
                        >
                            {expanded ? "Zwiń marki" : "Rozwiń wszystkie marki"}
                            <img src={logoIcon} alt="" className="search-btn-icon brands-expand-icon"/>
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
}

export default Brands;
